import { render, staticRenderFns } from "./TennisStadium.vue?vue&type=template&id=63e5eb1a&scoped=true"
import script from "./TennisStadium.vue?vue&type=script&lang=js"
export * from "./TennisStadium.vue?vue&type=script&lang=js"
import style0 from "./TennisStadium.vue?vue&type=style&index=0&id=63e5eb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5eb1a",
  null
  
)

export default component.exports